import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { useEffect, useRef } from 'react';

const KeenGallery = ({ slides = [], credit = '' }) => {
  // Initialize Keen Slider
  const [sliderRef, slider] = useKeenSlider({
    loop: true,
    mode: 'free', // enables swipe and continuous scroll
    renderMode: 'performance',
    slides: {
      perView: 'auto',
      spacing: 0,
    },
  });

  const autoScrollInterval = useRef(null);

  // Fix: Recalculate layout after load
  useEffect(() => {
    const timeout = setTimeout(() => {
      slider.current?.update(); // Force re-calculation after load
    }, 300);

    return () => clearTimeout(timeout);
  }, [slider]);

  // Auto-scroll function
  const startAutoScroll_XXXX = () => {
    autoScrollInterval.current = setInterval(() => {
      const next = slider.current.track.details.abs + 1;
      slider.current.moveToIdx(next);
    }, 2500); // auto-scroll every 2.5 seconds
  };

  const startAutoScroll = () => {
  autoScrollInterval.current = setInterval(() => {
    if (!slider.current || !slider.current.track || !slider.current.track.details) return;
    const currentIdx = slider.current.track.details.abs;
    const nextIdx = (currentIdx + 1) % slider.current.track.details.slides.length;
    slider.current.moveToIdx(nextIdx);
  }, 2500);
};

  const stopAutoScroll = () => {
    clearInterval(autoScrollInterval.current);
  };

  // Initialize auto-scroll on component mount
  useEffect(() => {
    startAutoScroll();

    return () => {
      stopAutoScroll();
    };
  }, [slider]);

  // Pause auto-scroll when user swipes
  useEffect(() => {
    if (!slider.current) return;

    const pauseAutoScrollOnSwipe = () => {
      stopAutoScroll(); // Stop the auto-scroll when dragging/swiping starts
    };

    const resumeAutoScrollAfterSwipe = () => {
      startAutoScroll(); // Resume auto-scroll after dragging/swiping ends
    };

    slider.current.on('dragStarted', pauseAutoScrollOnSwipe); // When user starts dragging
    slider.current.on('dragEnded', resumeAutoScrollAfterSwipe); // After swipe ends

    // Cleanup: Remove event listeners when component unmounts
    return () => {
      if (slider.current) {
        slider.current.off('dragStarted', pauseAutoScrollOnSwipe);
        slider.current.off('dragEnded', resumeAutoScrollAfterSwipe);
      }
    };
  }, [slider]);

  // Pause on hover
  useEffect(() => {
    const el = sliderRef.current;
    if (!el || !slider.current) return;

    const pause = () => stopAutoScroll();
    const resume = () => startAutoScroll();

    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);

    return () => {
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', resume);
    };
  }, [slider]);

  return (
    <div ref={sliderRef} className="keen-slider auto-scroll-gallery">
      {slides.map((img, idx) => (
        <div key={idx} className="keen-slider__slide" style={{ width: 'auto' }}>
          <div className="image-container">
            <img src={img.src} alt={img.title} />
            <div className="gallery_copyright">&copy; {credit}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeenGallery;